import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-3xl text-center" data-id="element-57" data-mp="3f1vodntmqpi5">
      {eyebrow && <p className="mb-3 text-sm font-bold uppercase tracking-[0.2em] text-brand/80" data-id="element-58" data-mp="3jzx3jxnxq4oc">{eyebrow}</p>}
      <h2 className="text-3xl font-black leading-[1.05] tracking-tight text-brand md:text-5xl" style={{
      textAlign: "center"
    }} data-id="element-59" data-mp="bjtvvrwtog00">
        {title}
      </h2>
      {subtitle && <p className="mt-4 text-lg text-muted md:text-xl" data-id="element-60" data-mp="gljbzlywjjuy">{subtitle}</p>}
    </div>;
}